export const darkTheme = {
    bg: "#3f4469",         // Dark background
    bgLight: "#1C1E27",    // Slightly lighter dark background
    primary: "#854CE6",    // Primary color for buttons, highlights
    text_primary: "#F2F3F4", // Primary text color
    text_secondary: "#B1B2B3", // Secondary text color
    card: "#171721",       // Background color for cards
    card_light: "#191924", // Lighter background for cards
    button: "#854CE6",     // Button color
    white: "#FFFFFF",      // White color for general use
    black: "#000000",      // Black color for general use
}

export const lightTheme = {
    bg: "#FFFFFF",         // White background
    bgLight: "#F0F0F0",    // Light gray background for sections or cards
    primary: "#BE1ADB",    // Primary color for buttons, highlights
    text_primary: "#111111", // Primary text color (dark gray)
    text_secondary: "#48494A", // Secondary text color (medium gray)
    card: "#FFFFFF", 
    card_light: "#FFFFFF",
    white: "#FFFFFF",
    black: "#FFFFFF",      // White background for cards
    button: "#5C5B5B",     // Button color (gray)
}
